<template>
  <div class="page-box">
    <!-- 头部组件 -->
    <ProductHeader :currentTab="0" stepTitle="价格与套餐"></ProductHeader>
    <div class="page-main">
      <!-- 发布助手 -->
      <PublishHelper></PublishHelper>
      <div class="main-content">
        <a-card :bordered="false" :headStyle="{borderBottom:'0px'}" :bodyStyle="{paddingTop:'0px'}">
          <a-row slot="title">
            <a-col :span="8">
              <span class="card-title">基础信息</span>
            </a-col>
          </a-row>
          <a-form-model ref="ruleForm" :model="ruleForm" :rules="rules"
                        :label-col="currentFormLayout.labelCol" :wrapper-col="currentFormLayout.wrapperCol"
          >
            <a-form-model-item label="商品标题" prop="proName">
              <a-input v-model="ruleForm.proName" :maxLength="120" placeholder="建议填写抢购商品名称">
                <span slot="addonAfter">{{ ruleForm.proName.length }}/120</span>
              </a-input>
            </a-form-model-item>
            <a-form-model-item label="介绍标语" prop="title">
              <a-textarea v-model="ruleForm.title" :maxLength="200" placeholder="请输入"
                          :auto-size="{ minRows: 3, maxRows: 5 }"/>
            </a-form-model-item>
            <a-form-model-item label="所在地区" prop="areaList">
              <!--              <AreaKinkage-->
              <!--                v-model="ruleForm.areaList"-->
              <!--                ref="areaData"-->
              <!--                @getAreaData="getAreaData" maxWidth="600px"></AreaKinkage>-->
              <AreaSelected
                v-model="ruleForm.areaList"
                :only-city="false"
                area-type="all"
                @change="onAreaChange"
                :changeOnSelect="false"
                :isNewCity="true"/>
            </a-form-model-item>
            <a-form-model-item label="详细地址" prop="address">
              <a-input v-model="ruleForm.address" @blur="getLongitude(false)" :maxLength="80"
                       placeholder="请输入详细地址"></a-input>
            </a-form-model-item>
            <!-- style="display:inline-block;" -->
            <a-form-model-item label="经纬度" style="margin-bottom:0;">
              <a-row :gutter="20">
                <a-col :span="8">
                  <a-form-model-item prop="longitude">
                    <a-input v-model="ruleForm.longitude" :maxLength="80" placeholder="请选择经度"
                             :disabled="true"></a-input>
                  </a-form-model-item>
                </a-col>
                <a-col :span="8">
                  <a-form-model-item prop="latitude">
                    <a-input v-model="ruleForm.latitude" :maxLength="80" placeholder="请选择纬度"
                             :disabled="true"></a-input>
                  </a-form-model-item>
                </a-col>
                <a-col :span="8">
                  <a-button @click="showMapEvent">选择</a-button>
                </a-col>
              </a-row>
            </a-form-model-item>
            <a-form-model-item label="景点主题">
              <a-cascader
                :fieldNames="{ label: 'label', value: 'value', children: 'children' }"
                :options="ticketThemeList"
                @change="(value, selectedOptions) => ticketThemeLevelIdChange(value, selectedOptions)"
                style="width: 420px"
                placeholder="请选择"></a-cascader>
              <a-button style="margin-left: 20px" @click="addThemeLevel">添加</a-button>
              <div class="tThemeLevelMain">
                <div v-for="(i,idx) in ticketThemeLevelArr" :key="idx" class="tThemeLevelBtn">
                  {{ i.ticketThemeThemeId ? i.ticketThemeThemeName : i.ticketThemeFirstLevelName }}
                  <a-icon @click="deleteThemeLevel(i,idx)" type="close-circle"/>
                </div>
              </div>
            </a-form-model-item>
            <a-form-model-item label="预约链接">
              <a-input :disabled="prepareUrlDisabled" placeholder="请输入预约链接"
                       v-model="ruleForm.prepareUrl"></a-input>
            </a-form-model-item>
            <a-form-model-item label="商品轮播图" prop="imgs">
              <custom-upload-pro-images v-model="ruleForm.imgs"
                                        :pro-id="proId" :multiple-selected="true"
                                        :draggableUpdate="true">
              </custom-upload-pro-images>
            </a-form-model-item>
            <a-form-model-item label="图文详情" required>
              <CustomUeditor v-model="ruleForm.proDes"></CustomUeditor>
            </a-form-model-item>
            <a-form-model-item label="费用包含">
              <a-textarea v-model="ruleForm.feeContain" :maxLength="500" placeholder="请输入"
                          :auto-size="{minRows:5,maxRows:10}"/>
            </a-form-model-item>
            <a-form-model-item label="预订须知">
              <a-textarea v-model="ruleForm.bookingNeed" :maxLength="500" placeholder="请输入"
                          :auto-size="{minRows:5,maxRows:10}"/>
            </a-form-model-item>
            <a-form-model-item label="发票模板" prop="invoiceTemplateId">
              <InvoiceSelect ref="InvoiceSelect" :proId="proId" :catalogId="catalogId"
                             v-model="ruleForm.invoiceTemplateId"></InvoiceSelect>
            </a-form-model-item>
            <a-form-model-item :wrapper-col="currentFormLayout.offsetCol">
              <a-button type="primary" :disabled="proSource!=0" @click="onSubmit" :loading="submitLoading">
                提交并下一步
              </a-button>
              <!-- <a-button  @click="backEvent" style="margin-left: 10px">保存草稿</a-button> -->
            </a-form-model-item>
          </a-form-model>
        </a-card>

      </div>
    </div>
    <!-- 天地图 -->
    <MapLocationPicker
      :visible.sync="showMap"
      :default-lat="ruleForm.proLatitude"
      :defaultLng="ruleForm.proLongitude"
      @confirm="mapConfirmEvent"
    ></MapLocationPicker>
  </div>
</template>

<script>
import ProductHeader from '../components/ProductHeader'
import PublishHelper from '../components/PublishHelper'
import ruleFormMixins from '@/utils/mixins/ruleFormMixins'
import AreaKinkage from '@/customComponents/AreaKinkage/AreaKinkage'
import CustomUploadProImages from '@/customComponents/CustomUploadProImages/CustomUploadProImages'
import CustomUeditor from '@/customComponents/CustomUeditor/CustomUeditor'
import InvoiceSelect from '../components/InvoiceSelect'
import AreaSelected from '@/customComponents/AreaSelected/AreaSelected'
import MapLocationPicker from '@/customComponents/MapLocationPicker/index.vue'
import { getLatAndLng, parserAddress } from '@/utils/helper/TianDiTuHelper'

export default {
  name: 'PresellBasicInfo',
  components: {
    ProductHeader,
    PublishHelper,
    AreaKinkage,
    MapLocationPicker,
    CustomUploadProImages,
    CustomUeditor,
    InvoiceSelect,
    AreaSelected
  },
  mixins: [ruleFormMixins],
  data() {
    return {
      proSource: this.$route.query.proSource, //判断自有产品还是非自有产品
      proId: this.$route.query.proId, //产品ID
      catalogId: this.$route.query.catalogId,
      showMap: false,
      ruleForm: {
        address: '',
        bookingNeed: '',
        cityId: '',
        countyId: '',
        feeContain: '',
        imgs: [],
        proDes: '',
        proId: '',
        proName: '',
        provinceId: '',
        title: '',
        longitude: '',
        latitude: '',
        areaList: [],//提交时删除
        invoiceTemplateId: undefined,//发票
        countryGroupId: '',
        countryId: ''
      },
      submitLoading: false,
      submitFormData: '',
      invoiceTemplateList: [],
      invoiceTemplateId: '',//发票ID
      rules: {
        proName: [
          { required: true, message: '请输入商品标题', trigger: 'blur' }
        ],
        title: [
          { required: true, message: '请输入介绍标语', trigger: 'blur' }
        ],
        areaList: [
          { type: 'array', required: true, message: '请选择所在地区', trigger: 'change' }
        ],
        address: [
          { required: true, message: '请输入详细地址', trigger: 'blur' }
        ],
        longitude: [
          {
            pattern: /^(\-|\+)?(((\d|[1-9]\d|1[0-7]\d|0{1,3})\.\d{0,20})|(\d|[1-9]\d|1[0-7]\d|0{1,3})|180\.0{0,20}|180)$/,
            message: '经度整数部分为0-180,小数部分最长20位',
            trigger: 'blur'
          }
        ],
        latitude: [
          {
            pattern: /^(\-|\+)?([0-8]?\d{1}\.\d{0,20}|90\.0{0,20}|[0-8]?\d{1}|90)$/,
            message: '纬度整数部分为0-90,小数部分最长20位',
            trigger: 'blur'
          }
        ],
        imgs: [
          { required: true, message: '请选择图片', trigger: ['blur', 'change'] }
        ],
        invoiceTemplateId: [
          { required: true, message: '请选择发票模板', trigger: 'change' }
        ]
      },
      ticketThemeList: [],//景点主题
      ticketThemeLevelArr: [],
      ticketThemeLevelSingle: {},
      selectedOptions: [],
      prepareUrlDisabled: false
    }
  },
  watch: {
    'ruleForm.areaList': function(value, old) {
      this.getLogUtils().logWithTag('watch', value)
    }
  },
  mounted() {
    this.getTicketInfoList()
    this.getProductInfo()
  },
  methods: {
    onAreaChange({ value, selectedOptions }) {
      this.selectedOptions = selectedOptions ? selectedOptions : []
    },
    getTicketInfoList() {// 景点门票信息联动
      this.getHttpServices().getProService().get('ticket/getThemeParam/8').then(res => {
        this.ticketThemeList = res
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    // 选择景点主题
    ticketThemeLevelIdChange(val, selectedOptions) {
      this.getLogUtils().logWithTag('ticketThemeLevelIdChange', val)
      this.getLogUtils().logWithTag('ticketThemeLevelIdChange', selectedOptions)
      if (selectedOptions) {
        let obj = {
          ticketThemeFirstLevelName: selectedOptions[0].label,
          ticketThemeFirstLevelId: selectedOptions[0].value,
          ticketThemeThemeName: selectedOptions[1] ? selectedOptions[1].label : '',
          ticketThemeThemeId: selectedOptions[1] ? selectedOptions[1].value : 0
        }
        this.ticketThemeLevelSingle = obj
      } else {
        this.ticketThemeLevelSingle = {}
      }
    },
    addThemeLevel() {
      this.getLogUtils().logWithTag('addThemeLevel', this.ticketThemeLevelSingle)
      if (this.ticketThemeLevelSingle && !this.ticketThemeLevelSingle.ticketThemeFirstLevelId) {
        this.$message.error('请选择景点主题')
        return
      }
      if (this.ticketThemeLevelArr.length > 19) {
        this.$message.error('景点主题不能超过20个')
        return
      }
      let flag = false
      if (this.ticketThemeLevelArr.length > 0) {
        this.ticketThemeLevelArr.forEach((v, k) => {
          if (v.ticketThemeThemeId) {
            if (v.ticketThemeFirstLevelId === this.ticketThemeLevelSingle.ticketThemeFirstLevelId && v.ticketThemeThemeId === this.ticketThemeLevelSingle.ticketThemeThemeId) {
              flag = true
            }
          } else {
            if (v.ticketThemeFirstLevelId === this.ticketThemeLevelSingle.ticketThemeFirstLevelId) {
              flag = true
            }
          }
        })
      }
      if (flag) {
        this.$message.error('请不要重复选择景点主题')
        return
      }
      this.ticketThemeLevelArr.push(this.ticketThemeLevelSingle)
    },
    deleteThemeLevel(i, idx) {
      if (this.ticketThemeLevelArr.length > 0) {
        this.ticketThemeLevelArr.splice(idx, 1)
      }
    },
    // 获取城市id(此方法取消)
    getAreaData(data) {
      this.ruleForm.areaList = data
      if (data && data.length > 0) {
        this.ruleForm.provinceId = data[0]
        this.ruleForm.cityId = data[1]
        this.ruleForm.countyId = data[2]
      }
      this.getLogUtils().logWithTag('getAreaData', this.ruleForm.areaList)
    },
    showMapEvent() {
      this.showMap = true
    },
    mapConfirmEvent(location) {
      this.getLogUtils().logWithTag('mapConfirmEvent', location)
      this.showMap = false
      this.ruleForm.longitude = location.lng
      this.ruleForm.latitude = location.lat
    },
    cancelShowMap() {
      this.showMap = false
    },
    checkForm() {
      if (!this.ruleForm.proDes) {
        this.$message.error('请输入图文详情')
        return false
      }
      return true
    },
    onSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          if (this.checkForm()) {
            this.getAreaList()//先调经纬度地址
          }
        } else {
          return false
        }
      })
    },
    // 保存接口
    submitData() {
      this.getLogUtils().logWithTag('submitData', this.ruleForm.areaList[0])
      this.submitLoading = true
      this.submitFormData = JSON.parse(JSON.stringify(this.ruleForm))
      this.submitFormData.themeList = this.ticketThemeLevelArr//景点主题
      this.submitFormData.imgs = this.submitFormData.imgs.length > 0 ? this.submitFormData.imgs.join(',') : ''
      delete this.submitFormData.areaList
      this.getLogUtils().logWithTag('submitData', this.submitFormData)
      this.getHttpServices().getProService().post('product/presale/saveOrUpdatePreSale', this.submitFormData).then(res => {
        this.getLogUtils().logWithTag('submitData', res)
        this.$message.success('抢购基本信息保存成功')
        this.ruleForm.proId = res
        this.$router.push({
          name: 'PresellBookSet',
          query: {
            proId: this.ruleForm.proId,
            catalogId: this.catalogId,
            proSource: this.proSource,
            isBack: this.proId == 0 ? 1 : undefined
          }
        })
      }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.submitLoading = false)
    },
    //更新区域地址
    getAreaList() {
      let data = this.ruleForm.areaList
      if (data && data.length > 0 && data[0] == 1) {
        this.ruleForm.countryGroupId = data[1] ? data[1] : 0
        this.ruleForm.countryId = data[2] ? data[2] : 0
        this.ruleForm.cityId = data[3] ? data[3] : 0
        this.ruleForm.provinceId = 0
        this.ruleForm.countyId = 0
        this.ruleForm.longitude = ''//经度
        this.ruleForm.latitude = ''//纬度
        this.submitData()
      } else {
        this.ruleForm.provinceId = data[1] ? data[1] : 0
        this.ruleForm.cityId = data[2] ? data[2] : 0
        this.ruleForm.countyId = data[3] ? data[3] : 0
        this.ruleForm.countryGroupId = 0
        this.ruleForm.countryId = 0
        this.getLongitude(true)
      }
    },
    //获取经纬度
    getLongitude(flag) {
      let data = this.ruleForm.areaList && this.ruleForm.areaList.length > 0 ? this.ruleForm.areaList[0] : null
      if (data != null && data == 0) {
        // let parms = {
        //   address:this.ruleForm.address,
        //   cityId: this.ruleForm.cityId?this.ruleForm.cityId:0,
        //   countyId:this.ruleForm.countyId?this.ruleForm.countyId:0,
        //   provinceId:this.ruleForm.provinceId?this.ruleForm.provinceId:0
        // }
        //this.getHttpServices().getProService().post("public/getBaiDuLatAndLng",parms)
        const realAddress = parserAddress(this.selectedOptions, this.ruleForm.address)
        getLatAndLng(this, realAddress).then(res => {
          this.getLogUtils().logWithTag('getLongitude', res)
          this.ruleForm.longitude = res.lng//经度
          this.ruleForm.latitude = res.lat//纬度
        }).catch(reason => {
          this.showNetWorkErrorMessage(reason)
        }).finally(() => {
          if (flag) {
            this.submitData()
          }
        })
      }
    },
    // 获取酒店基本信息
    getProductInfo() {
      if (this.proId != 0) {
        this.getHttpServices().getProService().get('product/presale/getPreSaleByProId/' + this.proId).then(res => {
          this.getLogUtils().logWithTag('getProductInfo', res)
          this.ruleForm = res
          if (!this.ruleForm.prepareUrlFlag) {
            this.prepareUrlDisabled = true
          }
          this.getLogUtils().logWithTag('this.ruleForm.prepareUrlFlag==\'true\'', this.ruleForm.prepareUrlFlag)
          if (res.provinceId) {
            this.ruleForm.areaList = [0, res.provinceId, res.cityId, res.countyId]
          } else if (res.countryGroupId) {
            this.ruleForm.areaList = [1, res.countryGroupId, res.countryId, res.cityId]
          } else {
            this.ruleForm.areaList = []
          }
          this.ticketThemeLevelArr = res.themeList ? res.themeList : []
          this.ruleForm.imgs = res.imgs && res.imgs != '' ? res.imgs.split(',') : []
          this.$refs.InvoiceSelect.getMatchTemplateId()
          this.ruleForm = { ...this.ruleForm }
          this.getLogUtils().logWithTag('getProductInfo', this.ruleForm)
        }).catch(reason => this.showNetWorkErrorMessage(reason))
      }
    }
  }

}
</script>
<style lang="less" scoped>
.page-box {
  .page-main {
    margin: 10px;
    display: flex;

    .main-content {
      margin-left: 10px;
      width: 400px;
      flex-grow: 1;
    }
  }
}

.pt10 {
  padding-top: 10px;
}

.card-title {
  padding-left: 10px;
  border-left: 1px solid #FAAD14;
  line-height: 32px;
  margin-right: 5px;
}

.tThemeLevelMain {
  .tThemeLevelBtn {
    display: inline-block;
    margin-right: 15px;
    padding: 0 10px;
    border: 1px #ccc solid;
    border-radius: 5px;
    line-height: 28px;
    font-size: 12px;
    cursor: pointer;
  }

  .tThemeLevelBtn:hover {
    border: 1px #FAAD14 solid;
  }
}
</style>